module.exports = __webpack_public_path__ + "6a6eb4d20cc651420f6e1557615fb038.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/Profile_Pic_Overlay_2.png
// module id = 158
// module chunks = 0